import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import PageShell from "../components/marketing/PageShell";
import PageHero from "../components/marketing/PageHero";
import CTAStrip from "../components/marketing/CTAStrip";
import FaqAccordion from "../components/marketing/FaqAccordion";
import { FAQS } from "../data/faqs";

export default function FAQPage() {
  return (
    <PageShell testid="page-faq">
      <SEO
        title="FAQ"
        description="Answers to the most common questions about BRep — subscriptions, coach vetting, turnaround times, refunds and more."
        path="/faq"
      />
      <Nav />
      <PageHero
        eyebrow="FAQ"
        title="Answers,"
        titleAccent="not marketing."
        subtitle="Everything you need to know before you book."
      />
      <section className="px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-4xl mx-auto">
          <FaqAccordion items={FAQS} />
        </div>
      </section>
      <CTAStrip
        title="Still have a question?"
        subtitle="Contact us and we'll get back to you."
        primary={{ to: "/contact", label: "Contact Us" }}
        secondary={{ to: "/services", label: "View Services" }}
      />
      <Footer />
    </PageShell>
  );
}
